import { render, staticRenderFns } from "./baiduempower.vue?vue&type=template&id=6a3fdef5&scoped=true&"
import script from "./baiduempower.vue?vue&type=script&lang=js&"
export * from "./baiduempower.vue?vue&type=script&lang=js&"
import style0 from "./baiduempower.vue?vue&type=style&index=0&id=6a3fdef5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3fdef5",
  null
  
)

export default component.exports